import React from 'react'

import useStyles from './styles'

const FacebookAdPreviewContainer = ({ children }) => {
  const classes = useStyles()

  return <div className={classes.adCard}>{children}</div>
}

export default FacebookAdPreviewContainer
